import Ext from "Ext";

/**
 * "Flat" button implementation, rendered as an anchor tag with text inside and an icon image in the background.
 *
 * @cfg {String} text button text.
 * @cfg {String} icon icon image URL.
 */
const FlatButton = Ext.extend(Ext.Button, {
    overCls: 'hover',
    buttonSelector: "a:first",
    cls: "at-flat-button",
    icon: "",
    text: "",

    initComponent: function() {
        FlatButton.superclass.initComponent.call(this);
        this.template = new Ext.Template('<div><a><span>{0}</span></a></div>');
    }
});

Ext.reg('at_flat_button', FlatButton);

export default FlatButton;


// WEBPACK FOOTER //
// ./web/js/controls/at_flat_button.js